<template>
    <div class="sidebar__section--border-bottom">
        <div v-if="route.isFirstOfDay" class="routes-result__subtitle routes-result__subtitle--spacious sidebar__section caption">
            Erste Verbindung an diesem Tag
        </div>
        <div v-else-if="route.isLastOfDay" class="routes-result__subtitle routes-result__subtitle--spacious sidebar__section caption">
            Letzte Verbindung an diesem Tag
        </div>
        <div v-else-if="route.showDateHeadline" class="routes-result__subtitle routes-result__subtitle--spacious sidebar__section caption">
            <span v-if="route.departureDate === routeTimeDateFormatted">
                Aktuelle Verbindungen <span class="dot-divider dot-divider--wide dot-divider--light"> {{ routeTimeDateFormatted }}</span>
            </span>
            <span v-else>
                Verbindungen am {{ route.departureDate }}
            </span>
        </div>
        <div class="routes-result-item" :class="{'is-active': active}">
            <div class="routes-result-item__main sidebar__section" @click="mainClickHandler">
                <div class="routes-result-item__header h3" ref="route-result-header">
                    <div class="routes-result-item__header__inner">

                        <div class="routes-result-item__header__section">
                            <div class="routes-result-item__header__mode" v-if="route.mode && listTab">
                                <Icon :height="22" :width="22">
                                    <TransportModeIcon :mode="route.mode"/>
                                </Icon>
                            </div>
                            <div class="routes-result-item__header__image" v-if="route.image">
                                <img :src="route.image" />
                            </div>
                            <span class="routes-result-item__header__duration highlighted" :class="[route.durationColor, { 'cancelled' : route.hasCancellation }]">
                                {{route.duration }}
                                <span class="delay caption" v-if="route.delays && route.delays.arrival">+ {{ route.delays.arrival }}</span>
                            </span>
                        </div>

                        <div class="routes-result-item__header__section">
                            <span class="routes-result-item__header__distance" v-if="route.distance">{{ route.distance }}</span>
                            <span class="routes-result-item__header__departure-arrival routes-result-item__copy dot-divider dot-divider--light dot-divider--wide copy-light" v-if="route.departureArrival">
                                <span v-if="route.departure">{{ route.departure }}</span>
                                <span v-if="route.departure" :class="route.delayDeparture !== 0  ? 'delay' : 'early'"> {{ route.delayDeparture >= 0 ? '+' : '' }}{{ route.delayDeparture }}</span>
                                <span> - </span>
                                <span v-if="route.arrival">{{ route.arrival }}</span>
                                <span v-if="route.arrival" :class="route.delayArrival !== 0  ? 'delay' : 'early'"> {{ route.delayArrival >= 0 ? '+' : '' }}{{ route.delayArrival }}</span>
                            </span>
                            <span class="routes-result-item__header__icons">
                                <span v-if="route.tolls && route.tolls.vignette">
                                    <SmrTooltip content="Vignettenpflicht - siehe Details" position="bottom-end">
                                        <Icon :height="16" :width="16">
                                            <IconVignette />
                                        </Icon>
                                    </SmrTooltip>    
                                </span>
                                <span v-if="route.construction">
                                     <SmrTooltip content="Baustelle" position="bottom-end">
                                        <Icon :height="16" :width="16" view-box="0 0 16 16">
                                            <IconConstruction />
                                        </Icon>
                                    </SmrTooltip>
                                </span>
                                <span v-if="route.warning">
                                    <SmrTooltip content="Wichtige Info - siehe Details" :position="route.tolls && route.tolls.vignette ? 'top' : 'right'">
                                        <Icon :height="16" :width="16" view-box="0 0 16 16">
                                            <IconWarning />
                                        </Icon>
                                    </SmrTooltip>
                                </span>
                                <span v-if="route.greenzones">
                                    <SmrTooltip content="Umweltzone" position="bottom-end">
                                        <Icon :height="16" :width="16" view-box="0 0 24 24">
                                            <IconGreenzone />
                                        </Icon>
                                    </SmrTooltip>
                                </span>
                                <span v-if="route.ecoSavings" class="green">
                                    <Icon :height="16" :width="16" view-box="0 0 24 24">
                                        <IconLeaf />
                                    </Icon>
                                </span>
                            </span>
                        </div>

                    </div>
                </div>
                <div class="routes-result-item__sections" v-if="route.sections">
                    <div class="routes-result-item__section" v-for="(section, sectionIndex) in route.sections" :key="sectionIndex">
                        <Icon :height="20" :width="20">
                            <PublicTransportIcon :mode="section.lineType ? section.lineType : section.type"/>
                        </Icon>
                        <span class="routes-result-item__section__duration copy-light" v-if="section.minuteDuration">{{ section.minuteDuration }}</span>
                        <span class="routes-result-item__section__name" :style="{'background-color': section.color}" v-if="section.name">{{ section.name }}</span>
                    </div>
                </div>

                <div class="copy-light routes-result-item__departure-time" v-if="shownRouteTime.mode === 'arrival' && route.departureTime">
                  {{ route.mode === 'FOOT' ? 'Start:' : 'Abfahrt:'}} <span v-if="route.departureDate">am {{ route.departureDate }} um </span> {{ route.departureTime }}
                </div>

                <div class="copy-ligh red" v-if="route.hasCancellation">
                    Verbindung entfällt
                </div>
                <div class="copy-ligh red" v-else-if="route.hasUnreachableConnection">
                    Anschluss kann voraussichtlich nicht erreicht werden
                </div>
                <div class="copy-light ui-overflow-hidden" v-else-if="route.gasPrice || route.tolls || route.transitions || route.fare || route.additionalMessage">
                    <span class="dot-divider dot-divider--info" v-if="route.gasPrice">Sprit ca. {{ route.gasPrice }}</span>
                    <span class="dot-divider dot-divider--info green" v-if="route.ecoSavings">Bis zu {{route.ecoSavings}}% sparen</span>
                    <span class="dot-divider dot-divider--info" v-if="route.tolls && route.tolls.tollSumEuro">Maut {{route.tolls.tollSumEuro}}</span>
                    <span class="dot-divider dot-divider--info" v-if="route.tolls && route.tolls.vignette">Vignettenpflicht: {{ route.tolls.vignette.map(entry => entry.country).join(', ') }}</span>
                    <span class="dot-divider dot-divider--info" v-if="route.transitions">{{route.transitions}} x Umsteigen</span>
                    <span class="dot-divider dot-divider--info" v-if="route.fare"> {{ route.showFareText ? 'Öffi-Ticket ca.' : '' }} {{ route.fare }}</span>
                    <span class="dot-divider dot-divider--info" v-if="route.additionalMessage">{{route.additionalMessage}}</span>
                </div>
                <div class="copy copy-light" v-if="routeShortTermParkingZone[route.mode]">Ziel in Kurzparkzone</div>
                <div class="copy copy-light routes-result-item__interimstop-alert" v-if="route.interimStopMessageAlert">
                    <span>Hinweis:</span> Bei öffentlichen Verkehrsmitteln werden keine Zwischenziele berücksichtigt.
                </div>
            </div>
            <div class="routes-result-item__actions sidebar__section" v-if="active">
                <ItemSlider slider-class="routes-result-item__actions__slider" :slider-options="actionSliderOptions" :tooltips="tooltipArrowsContent">
                    <SwiperSlide 
                        class="routes-result-item__actions__item" 
                        v-for="(action, actionIndex) in actions" 
                        :key="actionIndex"
                    >
                        <SharingActionsPopup v-if="action.id === 'share'">
                            <SmrButton size="tiny" color="grey" icon="" :round="true" :outline="true" @click.native="actionClickHandler(action.id)">
                                {{action.label}}
                                <Icon v-if="action.icon" slot="icon" :width="20" :height="20"><component :is="action.icon" /></Icon>
                            </SmrButton>
                        </SharingActionsPopup>
                        <SmrButton v-else size="tiny" color="grey" icon="" :round="true" :outline="true" :loading="action.loading" @click.native="actionClickHandler(action.id)">
                            {{action.label}}
                            <Icon v-if="action.icon" slot="icon" :width="20" :height="20"><component :is="action.icon" /></Icon>
                        </SmrButton>
                    </SwiperSlide>
                </ItemSlider>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import { formatPrice } from '@/utils/format'
import { trackEvent, trackGa4Event } from '@/utils/tracking'

import SmrButton from '@/components/SmrButton.vue'
import SmrTooltip from '@/components/SmrTooltip'
import TransportModeIcon from '@/components/TransportModeIcon.vue'
import PublicTransportIcon from '@/components/PublicTransportIcon.vue'
import ItemSlider from '@/components/ItemSlider.vue'
import Icon from '@/components/Icon.vue'
import IconVignette from '@/components/icons/IconVignette.vue'
import IconConstruction from '@/components/icons/IconConstruction.vue'
import IconWarning from '@/components/icons/IconWarning.vue'
import IconStar from '@/components/icons/IconStar.vue'
import IconStarOutline from '@/components/icons/IconStarOutline.vue'
import IconInfo from '@/components/icons/IconInfo.vue'
import IconBell from '@/components/icons/IconBell.vue'
import IconExport from '@/components/icons/IconExport.vue'
import IconPdf from '@/components/icons/IconPdf.vue'
import IconGreenzone from '@/components/icons/IconGreenzone.vue'
import IconPackingList from '@components/icons/IconPackingList.vue';
import IconShare from '@components/icons/IconShare.vue';
import IconLeaf from '@components/icons/IconLeaf.vue';
import { TRAFFIC_ALERT_TRANSPORT_MODES } from '@/data/transportModesTypes'
import { shareLink } from '@/utils/sharing'
import SharingActionsPopup from '@/components/SharingActionsPopup.vue'

export default {
    components: {
        SmrButton,
        SmrTooltip,
        TransportModeIcon,
        PublicTransportIcon,
        ItemSlider,
        Icon,
        IconVignette,
        IconConstruction,
        IconWarning,
        IconStar,
        IconStarOutline,
        IconInfo,
        IconBell,
        IconExport,
        IconPdf,
        IconGreenzone,
        IconPackingList,
        IconShare,
        IconLeaf,
        SharingActionsPopup
    },
    props: {
        route: {
            type: Object
        },
        listTab: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            formattedRoute: false,
            actionSliderOptions: {
                slidesPerView: 'auto',
                spaceBetween: 6,
                watchOverflow: true,
                touchStartPreventDefault: false,
                freeMode: true,
                freeModeMomentumRatio: 0.5,
            },
            tooltipArrowsContent: {
                left: {
                    content: 'Weitere Optionen',
                    position: 'top'
                },
                right: {
                    content: 'Weitere Optionen',
                    position: 'right'
                }
            },
        }
    },
    computed: {
        ...mapGetters(['routeTimeDateFormatted', 'routeTrafficTime', 'routeShortTermParkingZone', 'isSavedRoute', 'savedRouteInfo', 'activeRouteSaved', 'activeTransportModeTab', 'savedRouteTime', 'isMAPage', 'mobile']),
        actions() {
            let actions = [
                {
                    label: 'Details',
                    icon: 'IconInfo',
                    id: 'details',
                },
                {
                    label: this.showAsSavedRoute ? 'Gespeichert' : 'Speichern',
                    icon: this.showAsSavedRoute ? 'IconStar' : 'IconStarOutline',
                    loading: false,
                    id: this.showAsSavedRoute ? 'remove' : 'save',
                },
                {
                    label: 'Drucken',
                    icon: 'IconPdf',
                    id: 'print',
                },
                {
                    label: 'Teilen',
                    icon: 'IconShare',
                    id: 'share',
                },
            ];

            if(TRAFFIC_ALERT_TRANSPORT_MODES.includes(this.route.mode)) {
                const trafficAlertAction = {
                    label: 'Traffic Alert',
                    icon: 'IconBell',
                    id: 'traffic-alert',
                    loading: false,
                };
                actions.splice(4, 0, trafficAlertAction);
            }

            if(this.isMAPage) {
                const packingListAction = {
                    label: 'Packliste',
                    icon: 'IconPackingList',
                    id: 'packing-list',
                    loading: false,
                }
                actions.splice(1, 0, packingListAction);
            }

            return actions;
        },
        showAsSavedRoute() {
            if(this.activeTransportModeTab === 'LIST' && this.activeRouteSaved && this.activeRouteSaved.mode === this.route.mode) return true
            return this.isSavedRoute
        },
        shownRouteTime() {
            return this.savedRouteTime || this.routeTrafficTime
        },
    },
    watch: {
        route() {
            requestAnimationFrame(() => {
                this.wrapRouteHeaders();
            })
        }
    },
    mounted() {
        this.wrapRouteHeaders();
    },
    filters: {
        formatPrice(price) {
            return formatPrice(price)
        },
    },
    methods: {
        actionClickHandler(id) {
            switch(id) {
                case 'details':
                    this.openRouteDetails();
                    break;
                case 'save':
                    this.openFavouritePanel();
                    break;
                case 'remove':
                    this.removeSavedRoute()
                    break
                case 'traffic-alert':
                    this.openFavouritePanel(true);
                    break;
                case 'print':
                    this.showPrintPreview()
                    break;
                case 'packing-list':
                    this.showPackingList()
                    break;
                case 'share':
                    this.shareRoute()
                    break;
            }
            this.$emit('actionClickHandler');
        },
        mainClickHandler() {
            if(this.active) {
                this.openRouteDetails();
            }
        },
        wrapRouteHeaders() {
            let header = this.$refs['route-result-header'];
            if(header) {
                if(header.childNodes[0].clientWidth > header.clientWidth) {
                    header.classList.add('is-header-wrapped');
                }
            }
        },
        openRouteDetails() {
            trackEvent({ category: 'Route Planner', action: 'Route', label: 'Details' }); 
            trackGa4Event({ga4Parameter1Name: 'route', ga4Parameter1Value: 'details', ga4Event: 'route_planner'})
            this.$store.dispatch('setDetailRoute', {id: this.route.id, mode: this.route.mode});
        },
        openFavouritePanel(trafficAlert = false) {
            if(trafficAlert) {
                trackEvent({ category: 'Route Planner', action: 'Route', label: 'Traffic Alert' }); 
                trackGa4Event({ga4Parameter1Name: 'route', ga4Parameter1Value: 'save_traffic_alert_on', ga4Event: 'route_planner'})
            } else {
                trackEvent({ category: 'Route Planner', action: 'Route', label: 'Save' }); 
                trackGa4Event({ga4Parameter1Name: 'route', ga4Parameter1Value: 'save', ga4Event: 'route_planner'})
            }
            eventBus.$emit('showFavouritesPanel', {
                type: 'route',
                mode: this.route.mode,
                polylines: this.route.polylines,
                trafficAlert: trafficAlert,
                duration: this.route.durationUnformatted,
                distance: this.route.distanceUnformatted
            });
        },
        showPrintPreview() {
            trackEvent({ category: 'Route Planner', action: 'Route', label: 'Print' }); 
            trackGa4Event({ga4Parameter1Name: 'route', ga4Parameter1Value: 'print', ga4Event: 'route_planner'})
            eventBus.$emit('showPrintPreview', this.route.id)
        },
        showPackingList() {
            eventBus.$emit('showPackingList', { route: this.route })
            trackGa4Event({ ga4Parameter1Name: 'options', ga4Parameter1Value: 'open', ga4Event: 'packing_list_route' })
        },
        async shareRoute() {
            if(navigator.share && this.mobile) {
                shareLink()
            }
        },
        removeSavedRoute() {
            eventBus.$emit('showFavouriteRemovalConfirmation', () => { 
                this.$store.dispatch('resetSavedRouteSettings', false) // to turn star inactive immediately
                this.$store.dispatch('removeSavedRoute', this.savedRouteInfo.id)
            }, 'route')
        }
    }
}
</script>

<style lang="scss">
.routes-result-item {
    $block: &;
    position: relative;
    padding-top: 25px;
    padding-bottom: 25px;
    cursor: pointer;

    .no-touch &:hover:not(.is-active) {
        background-color: $color-grey-lightest;
        border-bottom-color: transparent;
        #{$block}__sections {
            &::after {
                background: linear-gradient(-90deg, rgba($color-grey-lightest, 1), rgba($color-grey-lightest, 0));
            }
        }
        .item-slider__navigation__arrow{
            background: $color-grey-lightest;
            &--prev:before {
                background: linear-gradient(90deg, rgba($color-grey-lightest,1) 0%, rgba($color-grey-lightest,0) 100%);
            }
            &--next:before {
                background: linear-gradient(270deg, rgba($color-grey-lightest,1) 0%, rgba($color-grey-lightest,0) 100%);
            }
        }
    }
    &.is-active {
        &:before {
            content: '';
            display: block;
            width: 5px;
            height: 100%;
            background: $color-yellow;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 10;
        }
    }

    &__main {
        &:not(:last-child) {
            margin-bottom: 24px;
        }
    }

    &__header {
        display: flex;
        &:not(:last-child) {
            margin-bottom: 5px;
        }

        &__inner {
            display: flex;
            align-items: center;
            flex-shrink: 0;

            .is-header-wrapped &{
                flex-direction: column;
                align-items: flex-start;
                margin-bottom: 7px;
            }
        }

        &__section {
            display: flex;
            align-items: center;
            .is-header-wrapped &{
                &:not(:last-child) {
                    margin-bottom: 4px;
                }
            }
            .is-header-wrapped &{
                & > *:first-child {
                    padding-left: 0;
                    margin-left: 0;
                    &::before {
                        display: none;
                    }
                }
            }
        }

        &__mode {
            margin-right: 5px;
            color: $color-grey-dark;
            margin-top: -2px;
            svg {
                display: block;
            }
        }

        &__image {
            width: 20px;
            margin-right: 6px;
            line-height: 0;
            img {
                width: 100%;
            }
        }


        .highlighted {
            display: flex;
            align-items: center;

            &.green {
                color: $color-green;
                .delay {
                    background: $color-green
                }
            }
            &.orange {
                color: $color-orange;
                .delay {
                    background: $color-orange
                }
            }

            .delay {
                font-weight: $font-weight-medium;
                color: white;
                padding: 3px 4px;
                border-radius: 4px;
                height: 18px;
                line-height: 1;
                margin-left: 5px;
            }
        }

        &__distance {
            white-space: nowrap;
            position: relative;
            padding-left: 8px;
            margin-left: 5px;
            &:not(:last-child) {
                margin-right: 12px;
            }
            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                width: 3px;
                height: 3px;
                border-radius: 3px;
                background-color: $color-black;
                margin-top: -1px;
            }
        }

        &__departure-arrival {
            font-weight: $font-weight-regular;
            &:not(:last-child) {
                margin-right: 12px;
            }

            .delay {
                color: $color-red;
            }

            .early {
                color: $color-green;
            }
        }

        &__icons {
            display: flex;
            color: $color-grey-dark;
            span {
                @include flex-center;
                width: 18px;
                height: 18px;
                border-radius: 4px;
                background: $color-black-005;

                &:not(:last-child) {
                    margin-right: 7px;
                }
            }
        }
    }

    &__sections {
        display: flex;
        align-items: center;
        overflow: hidden;
        width: 100%;
        position: relative;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
        &::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 30px;
            background: linear-gradient(-90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        }
    }

    &__section {
        color: $color-grey-dark;
        position: relative;
        display: flex;
        align-items: center;
        svg {
            display: block;
        }
        &:not(:last-child) {
            margin-right: 20px;
            &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 100%;
                margin-left: 5px;
                width: 10px;
                height: 2px;
                background-color: $color-grey-light;
            }
        }
        &__duration {
            font-size: 12px;
            transform: translate(-1px, -4px);
        }
        &__name {
            color: white;
            border-radius: 2px;
            font-weight: $font-weight-bold;
            font-size: 12px;
            line-height: 1;
            padding: 2px 3px;
            margin-left: 1px;
            white-space: nowrap;
        }
    }

    &__actions {
        position: relative;
        &__item {
            width: auto;
        }
    }

    &__departure-time {
        margin-bottom: 2px;
    }

    &__interimstop-alert {
        margin-top: 12px;

        span {
            font-weight: 500;
        }
    }
}
</style>